<template>
  <v-popup @close="$emit('close')" class="version-popup">
    <div>
      <div class="version-popup__item">
        FE Jenkins: {{ jenkinsFrontendVersion.branch }}
        <br />
        Build: {{ jenkinsFrontendVersion.build }},
        {{ jenkinsFrontendVersion.date }}
      </div>
      <div class="version-popup__item">
        FE DevOps: {{ devopsFrontendVersion.branch }}
        <br />
        Build:
        {{ devopsFrontendVersion.build }}, {{ devopsFrontendVersion.date }}
      </div>
      <div class="version-popup__item">BE DevOps: {{ buildNumber }}</div>
    </div>
  </v-popup>
</template>

<script>
import { VPopup } from "shared";
import * as VersionsDAO from "../../dao/versions-dao";

export default {
  name: "version-popup",
  components: { VPopup },
  data: () => ({
    isLoading: true,
    buildNumber: null,
    jenkinsFrontendVersion: {},
    devopsFrontendVersion: {}
  }),
  async created() {
    try {
      this.buildNumber = (await VersionsDAO.getBackendVersion()).buildnumber;
    } catch (e) {
      // catch error
    }
    try {
      this.jenkinsFrontendVersion = (await VersionsDAO.getFrontendJenkinsVersion()).data;
    } catch (e) {
      // catch error
    }
    try {
      this.devopsFrontendVersion = (await VersionsDAO.getFrontendDevopsVersion()).data;
    } catch (e) {
      // catch error
    }

    this.isLoading = false;
  }
};
</script>

<style lang="scss" scoped>
.version-popup {
  ::v-deep.popup__container {
    min-width: 0;
    width: 100%;
    max-width: 400px;
    padding: 20px;
  }
  &__item {
    color: #000;
    line-height: 16px;
    &:not(:last-child) {
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid gainsboro;
    }
  }
}
</style>
